import { render, staticRenderFns } from "./AlphabetForm.vue?vue&type=template&id=0ef8588a&scoped=true&lang=pug&"
import script from "./AlphabetForm.vue?vue&type=script&lang=js&"
export * from "./AlphabetForm.vue?vue&type=script&lang=js&"
import style0 from "./AlphabetForm.vue?vue&type=style&index=0&id=0ef8588a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef8588a",
  null
  
)

export default component.exports